import React from 'react';
import ReactDom from 'react-dom/client'; // Importer createRoot à la place de ReactDOM
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

// Créer une racine
const root = ReactDom.createRoot(document.getElementById('root')); 

// Rendre l'application
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
